<template>
  <BaseModal :isVisible="isVisible">
    <CreationCouleurForm :onCancel="closeModal" />
  </BaseModal>
</template>

<script setup>

import {CouleurStore} from "@/stores/CouleurStore";
import {defineProps} from "vue";
import BaseModal from "@/components/molecules/BaseModal.vue";
import CreationCouleurForm from "@/components/organismes/CreationCouleurForm.vue";

const couleurStore = CouleurStore();

defineProps({
  isVisible: {
    type: Boolean,
    required: true
  }
});

const closeModal = () => {
  couleurStore.showModalCreation = false;
}

</script>

<style scoped>

</style>